import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { MenuItemProps } from './MenuItem'
import DivLink from './DivLink'
import Icon from './Icon'

interface SubMenuItemProps extends MenuItemProps {
    onRoute: () => void
}

export default class SubMenuItem extends Component<SubMenuItemProps> {
  render () {
    const icon = this.props.icon || null
    return icon &&
            <DivLink
                to={this.props.to}
                className="cursor-pointer"
                onClick={this.props.onRoute}>
                <NavLink
                    exact={true}
                    to={this.props.to}
                    className='flex items-center'
                    activeClassName="bg-orange-400">
                    <div className="w-7 h-7 flex justify-center items-center rounded-full">
                        <Icon
                            name={icon}
                            size="medium"
                            color="white"/>
                    </div>
                    <p className="ml-2 text-white">
                        {this.props.text}
                    </p>
                </NavLink>
            </DivLink>
  }
}
